"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualMenuItemType = exports.DirectionalHint = void 0;
var DirectionalHint_1 = require("../../common/DirectionalHint");
Object.defineProperty(exports, "DirectionalHint", { enumerable: true, get: function () { return DirectionalHint_1.DirectionalHint; } });
/**
 * {@docCategory ContextualMenu}
 */
var ContextualMenuItemType;
(function (ContextualMenuItemType) {
    ContextualMenuItemType[ContextualMenuItemType["Normal"] = 0] = "Normal";
    ContextualMenuItemType[ContextualMenuItemType["Divider"] = 1] = "Divider";
    ContextualMenuItemType[ContextualMenuItemType["Header"] = 2] = "Header";
    ContextualMenuItemType[ContextualMenuItemType["Section"] = 3] = "Section";
})(ContextualMenuItemType = exports.ContextualMenuItemType || (exports.ContextualMenuItemType = {}));
//# sourceMappingURL=ContextualMenu.types.js.map